import {
  Body1,
  MoiaButton,
  MoiaDialog,
  MoiaDialogContent,
  MoiaDialogFormFooter,
  MoiaDialogHeader,
} from '@backoffice-frontend/patterns'
import type { ReactNode } from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type NotImplementedProps = {
  children: ReactNode
  className?: string
}

/*
A temporary wrapper-component for buttons that are not yet implemented.
It wraps the child with a click handler that opens a dialog with a message.
*/
export const NotImplemented = ({
  children,
  className,
}: NotImplementedProps) => {
  const { t } = useTranslation()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <>
      <div
        role="button"
        onClick={() => setIsDialogOpen(true)}
        css={{ display: 'flex' }}
        className={className}
      >
        {children}
      </div>
      <MoiaDialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
        <MoiaDialogHeader title={t('adFleetMap_comingSoon_label')} />
        <MoiaDialogContent>
          <Body1>{t('adFleetMap_workInProgress_message')}</Body1>
        </MoiaDialogContent>
        <MoiaDialogFormFooter
          trailing={
            <MoiaButton onClick={() => setIsDialogOpen(false)} color="primary">
              {t('adFleetMap_okayTakeMeBack_button')}
            </MoiaButton>
          }
        />
      </MoiaDialog>
    </>
  )
}
